import { render, staticRenderFns } from "./BulkSendSending.vue?vue&type=template&id=38f198a7&scoped=true&"
import script from "./BulkSendSending.vue?vue&type=script&lang=js&"
export * from "./BulkSendSending.vue?vue&type=script&lang=js&"
import style0 from "./BulkSendSending.vue?vue&type=style&index=0&id=38f198a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f198a7",
  null
  
)

export default component.exports